<template>
  
  <div class="blue-grey lighten-4 login">

    <v-content>
        <v-container class="mt-3 pa-6" fluid style="height: 100vh !important;">
            
            <v-row align="center" justify="center" class="pt-10 pb-10">
                <div class="headline">Data Record</div>
            </v-row>

            <v-card max-width="450" class="mx-auto" transition="slide-y-transition">
                <div class="headline pt-4 pb-2 text-center">Login</div>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation class="px-6">

                        <v-alert v-show="this.$store.state.isError" dismissible dense type="error" class="mt-3">{{ this.$store.state.isError }}</v-alert>

                        <v-text-field v-model="email" clearable :rules="emailRules" label="Email Address" @focus="clearError" required></v-text-field>
                        <v-text-field v-model="password" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" 
                        :rules="[rules.required]"
                        :type="show ? 'text' : 'password'"
                        name="password"
                        label="Password"
                        @click:append="show = !show"
                        @keyup.enter="signIn"
                        required
                        ></v-text-field>
                        <v-btn color="blue-grey white--text" block class="mt-6" :loading="$store.state.isLoginLoading" :disabled="!valid" @click="signIn">Login</v-btn>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-container>
    </v-content>

  </div>

</template>

<script>
export default {
    
    name: 'Login',

    data: () => ({

        email: '',
        password: '',

        valid: true,
        show: false,
        emailRules: [
            v => !!v || 'Email is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        rules: {
            required: value => !!value || 'Required.'
        },

        isLoading: false,
        isError: null
    }),

    methods: {

        signIn() {
            if (this.valid) {
                this.$store.state.isLoginLoading = true
                this.$store.dispatch('userLogin', { email: this.email, password: this.password });
            }
        },

        clearError() { this.$store.state.isError = false },

    },


}
</script>

<style>

</style>